export default __webpack_public_path__ + "static/media/pressure.d9badd3b.svg";